import React, {PureComponent} from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter
} from 'reactstrap';

export default class Alert extends PureComponent {
	constructor(props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
		this.handleOK = this.handleOK.bind(this);
	}
	
	handleClose() {
		this.props.onClose && this.props.onClose();
	}
	
	handleOK() {
		this.props.onOK && this.props.onOK();
	}
	
	render() {
		return (
			<Modal isOpen={true}>
				<ModalHeader>{this.props.header}</ModalHeader>
				<ModalBody>{this.props.content}</ModalBody>
				<ModalFooter>
					{this.props.cancelTitle && (
						<Button onClick={this.handleClose}>{this.props.cancelTitle}</Button>
					)}
					<Button color={this.props.type || "primary"} onClick={this.handleOK}>{this.props.okTitle}</Button>
				</ModalFooter>
			</Modal>
		);
	}
	
}


// WEBPACK FOOTER //
// ./src/03-components/Alert/index.js